<template>
    <div>
        <loader-c class="py-10" v-if="isLoadingPage || isLoadingData" :absolute="false"></loader-c>

        <app-banners-c v-if="showBanners && !isLoadingPage">
        </app-banners-c>

        <app-featured-access-c v-if="showFeaturedAccess && !isLoadingPage">
        </app-featured-access-c>

        <app-featured-items-c v-if="showFeaturedItems && !isLoadingPage">
        </app-featured-items-c>

        <app-mini-banners-c v-if="showMiniBanners && !isLoadingPage">
        </app-mini-banners-c>

        <app-latest-items-c v-if="showLatestItems && !isLoadingPage">
        </app-latest-items-c>
    </div>
</template>

<script>
import Template from '../../Shared/Layouts/Template1.vue';
import LoaderC from '../../../components/Shared/General/LoaderComponent.vue';
import AppBannersC from '../../../components/Template1/Home/BannersComponent.vue';
import AppFeaturedAccessC from '../../../components/Template1/Home/FeaturedAccessComponent.vue';
import AppFeaturedItemsC from '../../../components/Template1/Home/FeaturedItemsComponent.vue';
import AppMiniBannersC from '../../../components/Template1/Home/MiniBannersComponent.vue';
import AppLatestItemsC from '../../../components/Template1/Home/LatestItemsComponent.vue';

export default {

    layout: Template,

    components: {

        LoaderC,
        AppBannersC,
        AppFeaturedAccessC,
        AppFeaturedItemsC,
        AppMiniBannersC,
        AppLatestItemsC,

    },

    data() {

        return {

            isLoadingPage: true,
            isLoadingData: false,

            showBanners: false,
            showFeaturedAccess: false,
            showFeaturedItems: false,
            showMiniBanners: false,
            showLatestItems: false,

        };

    },

    mounted() {

        $('#main-body').removeClass('gray-background');

        this.loadHome();

    },

    methods: {

        loadHome() {

            this.showBanners = Number(this.isMobile ? localStorage.getItem('banners_mobile_active') : localStorage.getItem('banners_active'));
            this.showFeaturedAccess = Number(localStorage.getItem('featured_access_active'));
            this.showFeaturedItems = Number(localStorage.getItem('featured_items_active'));
            this.showMiniBanners = Number(localStorage.getItem('mini_banners_active'));
            this.showLatestItems = Number(localStorage.getItem('latest_items_active'));

            this.isLoadingPage = false;
            this.isLoadingData = true;

            setTimeout(() => {

                this.isLoadingData = false;

            }, 500);

        },

    },

};
</script>
